<template>
  <div class="text-center">
    <v-card>
      <v-card-title>
        <span class="h6">Customer filters</span>
      </v-card-title>
      <v-card-subtitle>
        <span class="caption d-flex justify-start">* using multiple filters can cause delays</span>
      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="custnameseach"
                clearable
                label="Customer name (search)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="custstatusselected"
                :items="custstatus"
                item-text="custstatdesc"
                item-value="custstatval"
                clearable
                label="Block status"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="custlastinvselected"
                :items="custlastinv"
                item-text="custlastinvdesc"
                item-value="custlastinvval"
                clearable
                label="Last invoiced before (days)"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="custoutsoldselected"
                :items="custoutsold"
                item-text="custoutsolddesc"
                item-value="custoutsoldval"
                clearable
                label="Outstanding older than (days)"
                hint="*delay of upto 40 sec expected if used"
              ></v-select>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn color="primary" @click="applyCustFilters">
                Apply
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "Orderfilters",
  props: [],

  data() {
    return {
      custnameseach: "",
      custstatusselected: null,
      custstatus: [
        { custstatval: 0, custstatdesc: "Active" },
        { custstatval: 1, custstatdesc: "Blocked" },
      ],
      custlastinvselected: null,
      custlastinv: [
        { custlastinvval: 15, custlastinvdesc: "15" },
        { custlastinvval: 30, custlastinvdesc: "30" },
        { custlastinvval: 45, custlastinvdesc: "45" },
        { custlastinvval: 60, custlastinvdesc: "60" },
      ],
      custoutsoldselected: null,
      custoutsold: [
        { custoutsoldval: 15, custoutsolddesc: "15" },
        { custoutsoldval: 30, custoutsolddesc: "30" },
        { custoutsoldval: 45, custoutsolddesc: "45" },
        { custoutsoldval: 60, custoutsolddesc: "60" },
      ],
    };
  },

  computed: {},

  methods: {
    applyCustFilters() {
      this.$store.dispatch("getCustomersData", {
        smandocno: this.$store.getters.salesperson,
        search: this.custnameseach ? this.custnameseach : "",
        doctype: "",
        docno: "",
        blockstat: this.custstatusselected != null ? this.custstatusselected : "",
        lastinv: this.custlastinvselected != null ? this.custlastinvselected : "",
        oldinv: this.custoutsoldselected != null ? this.custoutsoldselected : "",
        skip: 0,
        sortby: "",
        sortord: "",
      })
      this.$emit("hideCustFilters")
      console.log(this.custstatusselected)
      console.log(this.custlastinvselected)
      console.log(this.custoutsoldselected)
    },
  },
};
</script>
